"use client";
import { Controller, UseFormReturn } from "react-hook-form";
import { ChevronDown } from "lucide-react";
import { ComboBox, renderSelectOptions } from "cy-ui/components/Combobox";
import { Nationality } from "cy-api/simple-payments/ref-data/models";
import { Nil } from "cy-util";
import { AddressInputs } from "./models";

export function NationalitySelect({
  form,
  nationalities,
}: {
  nationalities: Nationality[];
  form: UseFormReturn<AddressInputs, any, AddressInputs>;
}) {
  return (
    <Controller
      control={form.control}
      name="nationality"
      render={(args) => (
        <NationalitySelectComponent
          onChange={(id) => args.field.onChange(id)}
          selectedId={args.field.value}
          error={args.fieldState.error?.message}
          nationalities={nationalities}
        />
      )}
      rules={{ required: { message: "Required", value: true } }}
    />
  );
}

export function NationalitySelectComponent({
  nationalities,
  onChange,
  selectedId,
  error,
}: {
  nationalities: Nationality[];
  onChange: (id: number | null) => void;
  selectedId: number | Nil;
  error: string | Nil;
}) {
  return (
    <ComboBox<Nationality>
      buttonChildren={(val) => (
        <>
          {val?.name}
          <ChevronDown className="absolute right-2" />
        </>
      )}
      buttonClassName="flex-grow"
      error={!!error}
      getOptions={(query) => {
        query = query.trim().toLowerCase();
        return nationalities.filter(
          (x) => !query || x.name.toLowerCase().includes(query),
        );
      }}
      maxHeight={16 * 30}
      onChange={(x) => onChange(x?.id ?? null)}
      renderItems={(opts) =>
        renderSelectOptions(
          opts.map((x) => ({ value: x, key: x.id, label: x.name })),
        )
      }
      value={nationalities.find((x) => x.id === selectedId) || null}
    />
  );
}
